var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',_vm._b({},'b-row',_vm.attr,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }